enum HashAlgorithm {
	MD5 = 'md5',
	SHA1 = 'sha1',
	SHA256 = 'sha256',
	SHA384 = 'sha384',
	SHA512 = 'sha512',
	CRC32 = 'crc32',
}

export default HashAlgorithm;
